import React, {useRef, useState} from 'react';
import styles from './Form.module.css';
import logo from "./logo.png";
import {Menu} from "primereact/menu";
import {useNavigate} from "react-router-dom";
import {Button} from "primereact/button";
import CommonButton from "./../common/botton/Button";


export default function Form() {

    const navigate = useNavigate();
    const menu = useRef();

    const [items, setItems] = useState([
        {label: 'Über uns', command:() => navigate("/ueberuns")},
        {label: 'FAQ', command:() => navigate("/faq")}
    ]);


    return (
        <div>
            <div className={styles.root}>
                <div className="wrapper" style={{padding: '0px 30px'}}>
                    <table className="col-2 hidden lg:inline-block" style={{width: '100%'}}>
                        <tbody>
                        <tr>
                            <td >

                                <img src={logo} style={{height: '75px', cursor: 'pointer'}} onClick={() => navigate("/")}/>
                            </td>
                            <td style={{width: '100%'}}></td>
                            {items.map(item => (
                                <td className={styles.item}  onClick={() => item.command()}>
                                    {item.label}
                                </td>
                            ))}
                            {/*
                            <td>
                                <div className={styles.erklearvideoButton}>
                                    Erklärvideo
                                </div>
                            </td>
                            <td>
                                <CommonButton label="Antrag stellen"/>
                            </td>
                            */}
                        </tr>
                        </tbody>
                    </table>

                    <table className="lg:hidden" style={{width: '100%'}}>
                        <tbody>
                        <tr>
                            <td style={{width: '350px'}}>
                                <img src={logo} style={{height: '75px', cursor: 'pointer'}} onClick={() => navigate("/")}/>
                            </td>
                            <td style={{textAlign: 'right', paddingRight: '20px'}}>
                                <Menu model={items} popup ref={menu} id="popup_menu"/>
                                <Button
                                    icon="pi pi-bars"
                                    onClick={(event) => {
                                        console.log(menu)
                                        menu.current.toggle(event)
                                    }}
                                    aria-controls="popup_menu"
                                    aria-haspopup />
                            </td>
                        </tr>
                        </tbody>
                    </table>

                </div>
            </div>

            <div className="hidden lg:inline-block" style={{height: '100px'}}>
            </div>
            <div className="lg:hidden" style={{height: '100px'}}>
            </div>
        </div>
    )
}
